import { CardSection, Flex } from '@/lib/v2/components';

import { RulesEmailAction } from './RulesEmailAction';

import { useHiddenV1Container } from '@/modules/AutomationModuleNew/hooks/useHiddenV1Container';

const RulesEmailMain = () => {
  //TODO: review this classes in automation: z-0 w-full
  useHiddenV1Container();
  return (
    <div className="relative w-full bg-white">
      <CardSection noPadding>
        <Flex column>
          <RulesEmailAction />
        </Flex>
      </CardSection>
    </div>
  );
};

export default RulesEmailMain;
